(function(){
  const init = function(){
    const forms = document.querySelectorAll('form[action="/cart/add"]:not([data-recharge-loaded="true"])');
    
    if(forms && forms.length > 0){
      forms.forEach(function(form){
        const wrapper = form.querySelector('.mx-recharge-wrapper');
        
        if(wrapper) {
          initWrapper(form, wrapper);
        }
      });
    }    
  }
  
  const initWrapper = function(form, wrapper){
    const { id } = wrapper.dataset;
    if(!id) return;

    wrapper.innerHTML = '';
    
    const config = {
      productId: Number(id),
      injectionParent: wrapper,
      injectionMethod: 'prepend',
      selectors: {
        price: ['.none'],
        variant: ['.none']
      }
    };
    
    window.ReChargeWidget.createWidget(config);
    console.log('ReChargeWidget created');
    form.setAttribute('data-recharge-loaded', 'true');
  }
  
  let initialized = false;
  const rechargeWidgetInterval = setInterval(() => {
    if(window.ReChargeWidget && !initialized) {
      initialized = true;
      init();
      clearInterval(rechargeWidgetInterval);
    }
  }, 100);
})();